import {ReactElement} from 'react'
import {Trans} from 'react-i18next'
import {withdrawalPaymentVendors} from '@bdswiss/common-enums'

import messages from '../../../../../../assets/messages'
import {ReactComponent as VisaLogoIcon} from '../../../../../../assets/images/visa_logo_icon.svg'
import {ReactComponent as MastercardLogoIcon} from '../../../../../../assets/images/mastercard_logo_icon.svg'
import {Currency} from '../../../../../../graphql/types'
import {useStyles} from './styles'
import {getFormattedAmount} from '../../../../../../common/utils'

type AmountToRefundItemProps = {
  amount: number,
  currency: Currency | null,
  cardNumber: string,
  vendor: string,
}

function AmountToRefundItem(props: AmountToRefundItemProps): ReactElement {
  const classes = useStyles()
  const {amount, currency, cardNumber, vendor} = props

  const vendorLabel = withdrawalPaymentVendors[vendor]?.label

  return (
    <div className={classes.container}>
      <div className={classes.icons}>
        <VisaLogoIcon className={classes.icon} />
        <MastercardLogoIcon className={classes.icon} />
      </div>
      <div>
        <Trans
          {...messages.amountToRefund}
          values={{amount: getFormattedAmount({currency, amount}), cardNumber}}
          components={[<span className={classes.amount}>amount</span>]}
        />
      </div>
      {vendorLabel ? (
        <div className={classes.vendor}>
          {vendorLabel}
        </div>
      ) : null}
    </div>
  )
}

export {AmountToRefundItem}
